import React from "react";

export default function EnProdukacjaCopyrightNote() {
    return <>
        <hr className='text-white'/>
        <p className='text-white px-3 pt-3 mb-1 text-center fw-medium fs-10'>
            Questions? <span> </span>
            <br className='d-md-none'/>
            <a href="mailto:support@produkacja.pl" className='text-white text-decoration-none'>
                support@produkacja.pl
            </a>
        </p>
        <p className='text-secondary-light px-3 pt-3 mb-1 text-center fw-medium fs-11'>
            <a href="/en/privacy-policy" className='text-secondary-light text-decoration-none'>
                Privacy Policy
            </a>

            <span className='d-none d-md-inline'> | </span>
            <br className='d-md-none'/>
            <a href="/en/terms-of-service" className='text-secondary-light text-decoration-none'>
                Terms of Service
            </a>
        </p>
        <p className='text-secondary-light px-3 pt-3 mb-1 text-center fs-12'>
            © {new Date().getFullYear()} Produkacja sp. z o. o.
        </p>
        <p className='text-secondary-light px-3 pt-0 mb-1 text-center fs-12'>
            Wyścigowa 63, 53-011 Wrocław, Poland
        </p>
        <p className='text-secondary-light px-3 pt-0 mb-1 text-center fs-13'>
            KRS: 0001098787 | NIP: 8992990210 | REGON: 528312950
        </p>
    </>
}
